<div class="all-content">
  <div class="top">
    <div class="title">
      {{ parameters.isCreate ? getLanguages('personas/add') : parameters.isEdit ? getLanguages('personas/edit') :
      getLanguages('personas/view')}}
    </div>

    <i class="fas fa-xmark" (click)="exitModal()"></i>
  </div>
  <div class="buttons">
    <div class="save" (click)="setPersonasTree()"
      *ngIf="(isEdit) && getSystemPermission('organizational_structure', 'create')">
      {{ getLanguages('updateRow')}}
    </div>
    <div class="save" (click)="setPersonasTree()"
      *ngIf="(parameters.isCreate) && getSystemPermission('organizational_structure', 'create')">
      {{ getLanguages('addRow')}}
    </div>
    <div class="save" [ngClass]="isEdit? 'edit' : '' " (click)="editBusinessTree()"
      *ngIf="!parameters.isCreate && getSystemPermission('organizational_structure', 'edit')">
      {{ isEdit ? getLanguages('cancel') : getLanguages('edit') }}
    </div>
  </div>

  <div class="row">
    <div class="item item-2">
      <span> {{ getLanguages('personas/name') }} </span>
      <input [disabled]="!parameters.isEdit" type="text" [(ngModel)]="parameters.item.label">
    </div>
    <div class="item item-2">
      <span> {{ getLanguages('personas/type') }} </span>
      <button class="button-menu" [matMenuTriggerFor]="personasMenu"
        [disabled]="!parameters.isEdit || parameters?.item?.master == 'ROOT' || (parameters?.item?.size > 0 && parameters?.item?.data?.type == 'organogram')"
        [ngClass]="!parameters.isEdit || parameters?.item?.master == 'ROOT' || (parameters?.item?.size > 0 && parameters?.item?.data?.type == 'organogram') ? 'disabled' : 'pointer'">
        <span>
          {{ getNames(selectedPersonas.name) }}
        </span>
        <i class="fa-solid fa-caret-down" [ngClass]="!parameters.isEdit ? 'disabled' : ''"></i>
      </button>
      <mat-menu #personasMenu="matMenu">
        <div class="menu">
          <div class="input" (click)="$event.stopPropagation()">
            <input type="text" [(ngModel)]="searchPersonas" placeholder="{{ getLanguages('search') }}">
            <i class="fa-solid fa-magnifying-glass"></i>
          </div>
          <div class="scroll">
            <ng-container *ngFor="let personas of personasArray">
              <ng-container *ngIf="getNames(personas.name).toLowerCase().includes(searchPersonas.toLowerCase())">
                <div class="item-menu" (click)="choseItemSelect('personas', personas)">
                  <span
                    [ngClass]="getNames(personas.name) == getNames(selectedPersonas.name) ? 'valid-span' : 'invalid-span'">
                    {{ getNames(personas.name) }}
                  </span>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </mat-menu>
    </div>
  </div>

  <div class="row row-end">
    <div class="button-upload" (click)="newVariation()" *ngIf="parameters?.item?.data?.type == 'persona' && getSystemPermission('organizational_structure', 'create_variations')"    [ngClass]="!parameters.isEdit ? 'disabled' : 'pointer'">
        {{ getLanguages('personas/newSeniorityLevel') }}
    </div>
  </div>

  <div class="row" *ngIf="isDataVariations() && parameters?.item?.data?.type == 'persona'">
    <p-table [value]="getRows('variations')" class="table-project">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="seniority">
            <span> {{ getLanguages('personas/seniority') }} </span>
          </th>
          <th pSortableColumn="level">
            <span> {{ getLanguages('personas/level') }} </span>
          </th>
          <th pSortableColumn="fte_cost">
            <span> {{ getLanguages('personas/cost') }} </span>
          </th>
          <th pSortableColumn="history">
            <span> {{ getLanguages('personas/history') }} </span>
          </th>
          <th class="td-15">
            <span> {{ getLanguages('attachment/action') }} </span>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
        <tr>
          <td>
            <div class="item td-20" style="display: flex; align-items: center; gap: 5px;">
              <i class="fas fa-circle-exclamation" *ngIf="row?.error" [matTooltip]="getLanguages('businessSolution/modal/project/table/name_task_null')" style="color: var(--red, #e53935);"></i>
              <textarea 
                [disabled]="!parameters.isEdit" 
                [(ngModel)]="row.seniority"
                placeholder="{{ getLanguages('personas/seniority') }}"></textarea>
            </div>
          </td>
          <td>
            <textarea 
              [disabled]="!parameters.isEdit" 
              [(ngModel)]="row.level" 
              (input)="validateLevel($event)" 
              (keypress)="allowOnlyNumbers($event)"
              type="number"></textarea>
          </td>
          <td>
            <textarea 
              [disabled]="!parameters.isEdit" 
              [(ngModel)]="row.fte_cost" 
              (input)="formatFte($event, row)"
              (keypress)="validateFte($event, row)"
             >
            </textarea>
          </td>
          <td>
            <button 
              class="button-menu-table"  
              [disabled]="!parameters.isEdit" 
              [ngClass]="!parameters.isEdit ? 'no-pointer' : ''"
              (click)="activateHistory(row.uuid)">
              <span>
                {{ row.history || 'dd/mm/aaaa hh:mm:ss' }}
              </span>
              <i class="fa-solid fa-clock-rotate-left"></i>
            </button>
          </td>
          <td class="td-15">
            <div class="align-center" [ngClass]="!parameters.isEdit ? 'disabled-icon' : 'icon'">
              <i class="fas fa-trash pointer" (click)="deleteVariation(row.uuid)" [ngClass]="!parameters.isEdit ? 'disabled-icon no-pointer' : 'icon'"></i>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="div-paginator" *ngIf="isDataVariations() && parameters?.item?.data?.type == 'persona'">
    <div class="paginator">
      <span>
        {{ getLanguages('businessSolution/modal/strategy/itensPage') }}
      </span>
      <button [matMenuTriggerFor]="menu" class="itens-per-page">
        {{ getItemsPerPage() }}
      </button>
      <mat-menu #menu="matMenu" >
        <button mat-menu-item (click)="choseItemsPage(5)">5</button>
        <button mat-menu-item (click)="choseItemsPage(10)">10</button>
      </mat-menu>
      <span>
        {{ getLanguages('businessSolution/modal/strategy/totalPages') }}
      </span>
      <span class="totalPages">
        {{ getTotalNumberPages()}}
      </span>
      <button
        [ngClass]="getCurrentPages() === 1 ? 'disabled-arrow' : 'arrow'"
        [disabled]="getCurrentPages() === 1"
        (click)="setCurrentPages(getCurrentPages() - 1)">
        <i class="fa-solid fa-angle-left"></i>
      </button>
      <input type="number" [ngModel]="getCurrentPages()"  (blur)="checkValue()">
      <button
        [ngClass]="getCurrentPages() == getTotalNumberPages() ? 'disabled-arrow' : 'arrow'"
        [disabled]="getCurrentPages() == getTotalNumberPages()"
        (click)="setCurrentPages(getCurrentPages() + 1)">
        <i class="fa-solid fa-angle-right"></i>
      </button>
    </div>
  </div> 

  <div class="row">
    <div class="title-skills" *ngIf="parameters?.item?.data?.type == 'persona'">
      <span> {{ getLanguages('personas/specialties') }} </span>
      <i class="fa-solid fa-chevron-right" [ngClass]="!openSpecialties ? 'openned' : 'closed'" (click)="flipSpecialties()"></i>
      <i class="fa-solid fa-plus" (click)="addSpecialties()"
        *ngIf="getSystemPermission('organizational_structure', 'create_specialties')"
        [ngClass]="!parameters.isEdit ? 'no-pointer' : 'pointer'"></i>
    </div>
  </div>

  <div class="row">
    <div class="skills" *ngIf="parameters.item.data.type == 'persona'"
      [ngClass]="openSpecialties ? 'openned-skills' : 'closed-skills'">
      <div class="skill" *ngFor="let specialties of specialtiesArray">
        <input type="text" [(ngModel)]="specialties.name">
        <i class="fas fa-xmark" (click)="removeSpecialties(specialties.uuid)"
          *ngIf="getSystemPermission('organizational_structure', 'remove_specialties')"
          [ngClass]="!parameters.isEdit ? 'no-pointer' : 'pointer'"></i>
      </div>

      <div class="noData" *ngIf="specialtiesArray && specialtiesArray.length == 0">
        <div class="icon">
          <i class="fa-solid fa-exclamation"></i>
        </div>
        <span>
          {{ getLanguages('errors/noData')}}
        </span>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="title-skills" *ngIf="parameters?.item?.data?.type == 'persona'">
      <span> {{ getLanguages('personas/skills') }} </span>
      <i class="fa-solid fa-chevron-right" [ngClass]="!openSkills ? 'openned' : 'closed'" (click)="flipSkills()"></i>
      <i class="fa-solid fa-plus" (click)="addSkill()"
        *ngIf="getSystemPermission('organizational_structure', 'create_skills')"
        [ngClass]="!parameters.isEdit ? 'no-pointer' : 'pointer'"></i>

      <button class="save button-skills" [disabled]="!parameters.isEdit" (click)="exitModalSkills()"
        [ngClass]="!parameters.isEdit ? 'no-pointer disabled' : 'pointer'">
        {{ getLanguages('businessSolution/modal/skills/search') }}
      </button>
    </div>
  </div>

  <div class="row">
    <div class="skills" *ngIf="parameters.item.data.type == 'persona'"
      [ngClass]="openSkills ? 'openned-skills' : 'closed-skills'">
      <div class="skill" *ngFor="let skill of skillsArray">
        <input type="text" [(ngModel)]="skill.name" [disabled]='!parameters.isEdit || skill.in_use'>
        <i class="fas fa-xmark" (click)="removeSkill(skill.uuid)"
          *ngIf="getSystemPermission('organizational_structure', 'remove_skills') || skill.in_use == undefined"
          [ngClass]="!parameters.isEdit ? 'no-pointer' : 'pointer'"></i>
      </div>

      <div class="noData" *ngIf="skillsArray && skillsArray.length == 0">
        <div class="icon">
          <i class="fa-solid fa-exclamation"></i>
        </div>
        <span>
          {{ getLanguages('errors/noData')}}
        </span>
      </div>
    </div>
  </div>
</div>

<div class="background-modals" *ngIf="isShowSkills || history?.isShow">
  <app-skills-crud *ngIf="isShowSkills" (toggleExit)="exitModalSkills()" (getArray)="getArraySkillsPersona($event)"
    [parameters]="parameters"></app-skills-crud>

  <div class="modal-create-type modal-history" *ngIf="history?.isShow">
    <div class="top-create-type">
      <div class="toggle-create-type"></div>
      
      <i class="fas fa-xmark" (click)="history.isShow = false"></i>
    </div>

    <div class="row-create-type">
      <div class="title-create-type">
        <span> {{ getLanguages('personas/history') }} </span>
      </div>
    </div>

    <div class="row content">
      <div class="div-table">
        <p-table [value]="history?.displayedRows" class="table">
          <ng-template pTemplate="header">
            <tr>
              <th class="td-center-auto">
                <span class="columnTitle"> {{ getLanguages('personas/is_current') }} </span>
              </th>
              <th>
                <span class="columnTitle"> {{ getLanguages('personas/cost') }} </span>
              </th>
              <th>
                <span class="columnTitle"> {{ getLanguages('personas/start_date') }} </span>
              </th>
              <th>
                <span class="columnTitle"> {{ getLanguages('personas/end_date') }} </span>
              </th>
              <th>
                <span class="columnTitle"> {{ getLanguages('personas/user') }} </span>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-element let-rowIndex="rowIndex">
            <tr *ngIf="!element.is_delete" style="font-size: 1.4vh!important;">
              <td>
                <span class="columnText">
                  {{ element.is_current ? getLanguages('personas/yes') : getLanguages('personas/no') }}
                </span>
              </td>
              <td>
                <span class="columnText">
                  {{ element.fte_cost }}
                </span>
              </td>
              <td>
                <span class="columnText">
                  {{ element.start_date }}
                </span>
              </td>
              <td>
                <span class="columnText">
                  {{ element.end_date }}
                </span>
              </td>
              <td>
                <span class="columnText">
                  {{ element.user?.name }}
                </span>
              </td>
          </ng-template>
        </p-table>
      </div>
      <div class="div-paginator">
        <div class="paginator">
          <span>
            {{ getLanguages('businessSolution/modal/strategy/itensPage') }}
          </span>
          <button [matMenuTriggerFor]="menu" class="itens-per-page">
            {{ getItemsPerPage()}}
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="choseItemsPage(5)">5</button>
            <button mat-menu-item (click)="choseItemsPage(10)">10</button>
            <button mat-menu-item (click)="choseItemsPage(20)">20</button>
          </mat-menu>
          <span>
            {{ getLanguages('businessSolution/modal/strategy/totalPages') }}
          </span>
          <span class="totalPages">
            {{ getTotalNumberPages() }}
          </span>
          <button [ngClass]="getCurrentPages() === 1 ? 'disabled-arrow' : 'arrow'" [disabled]="getCurrentPages() === 1"
            (click)="setCurrentPages(getCurrentPages() - 1); getDisplayedRows();">
            <i class="fa-solid fa-angle-left"></i>
          </button>
          <input type="number" disabled [ngModel]="getCurrentPages()" (blur)="getTotalPages()">
          <button [ngClass]="getCurrentPages() >= getTotalNumberPages()  ? 'disabled-arrow' : 'arrow'"
            [disabled]="getCurrentPages() >= getTotalNumberPages()"
            (click)="setCurrentPages(getCurrentPages() + 1);getTotalPages();">
            <i class="fa-solid fa-angle-right"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>